import { formatAcceptHint, getAcceptTypes } from '@/shared/lib/utils/getAcceptTypes';

// Files of a session and of its steps: the same types the backend takes for lesson files
export const SESSION_ATTACHMENT_ACCEPT = getAcceptTypes({
  isImage: true,
  isDocuments: true,
  isSpreadsheet: true,
});

export const SESSION_ATTACHMENT_TYPES_HINT = formatAcceptHint(SESSION_ATTACHMENT_ACCEPT);
